export const LOAD_RESTAURANT = 'LOAD_RESTAURANT';
export const SUBMIT_RECOMMENDATION_SUCCESS = 'SUBMIT_RECOMMENDATION_SUCCESS';
